import React, { useState } from 'react'
import HeadlineAndBodyTextBlock from './HeadlineAndBodyTextBlock'
import ImportantNoticeBlock from './ImportantNoticeBlock'
import CodeExampleBlock from './CodeExampleBlock'
import GalleryBlock from './GalleryBlock'
// import ImageBlock from './ImageBlock'

const ContentImage = (values, position) => {
    const { h4, description, displayImportantNotice, importantNotice, image } = values

    return (
        <div className="content-row-item">
            {
                position ? (
                    <>
                        <div className="col-lg-6">
                            <div className="main-content">
                                <HeadlineAndBodyTextBlock
                                    headlines={[{ headlineValue: h4, headlineType: 'H4' }]}
                                    body={[{ bodyCopy: description }]}
                                />
                                {displayImportantNotice && (
                                    <ImportantNoticeBlock notice={importantNotice} />
                                )}
                            </div>
                        </div>
                        <div className="col-lg-1"></div>
                        <div className="col-lg-5">
                            <div className="content-listener-image">
                                {
                                    image && (
                                        <GalleryBlock gallery={[image]} />
                                        // <ImageBlock image={image}></ImageBlock>
                                    )
                                }
                            </div>
                        </div>
                    </>
                ) : (
                        <>
                            <div className="col-lg-5">
                                <div className="content-listener-image">
                                    {
                                        image && (
                                            <GalleryBlock gallery={[image]} />
                                            // <ImageBlock image={image}></ImageBlock>
                                        )
                                    }
                                </div>
                            </div>
                            <div className="col-lg-1"></div>
                            <div className="col-lg-6">
                                <div className="main-content">
                                    <HeadlineAndBodyTextBlock
                                        headlines={[{ headlineValue: h4, headlineType: 'H4' }]}
                                        body={[{ bodyCopy: description }]}
                                    />
                                    {displayImportantNotice && (
                                        <ImportantNoticeBlock notice={importantNotice} />
                                    )}
                                </div>
                            </div>
                        </>
                    )
            }
        </div>
    )
}

const ContentSvg = (values, position) => {
    const { h4, description, displayImportantNotice, importantNotice, svg } = values

    return (
        <div className="content-row-item">
            {
                position ? (
                    <>

                        <div className="col-lg-6">
                            <div className="main-content">
                                <HeadlineAndBodyTextBlock
                                    headlines={[{ headlineValue: h4, headlineType: 'H4' }]}
                                    body={[{ bodyCopy: description }]}
                                />
                                {displayImportantNotice && (
                                    <ImportantNoticeBlock notice={importantNotice} />
                                )}
                            </div>
                        </div>
                        <div className="col-lg-1"></div>
                        <div className="col-lg-5"><div className="logo-svg" dangerouslySetInnerHTML={{ __html: svg }}></div></div>
                    </>
                ) : (
                        <>
                            <div className="col-lg-5"><div className="logo-svg" dangerouslySetInnerHTML={{ __html: svg }}></div></div>
                            <div className="col-lg-1"></div>
                            <div className="col-lg-6">
                                <div className="main-content">
                                    <HeadlineAndBodyTextBlock
                                        headlines={[{ headlineValue: h4, headlineType: 'H4' }]}
                                        body={[{ bodyCopy: description }]}
                                    />
                                    {displayImportantNotice && (
                                        <ImportantNoticeBlock notice={importantNotice} />
                                    )}
                                </div>
                            </div>
                        </>
                    )
            }
        </div>
    )
}

const ContentCodeExample = (values, position) => {
    const { h4, description, displayImportantNotice, importantNotice, codeExample } = values

    return (
        <div className="content-row-item">
            {
                position ? (
                    <>
                        <div className="col-lg-6">
                            <div className="main-content">
                                <HeadlineAndBodyTextBlock
                                    headlines={[{ headlineValue: h4, headlineType: 'H4' }]}
                                    body={[{ bodyCopy: description }]}
                                />
                                {displayImportantNotice && (
                                    <ImportantNoticeBlock notice={importantNotice} />
                                )}
                            </div>
                        </div>
                        <div className="col-lg-1"></div>
                        <div className="col-lg-5">
                            <CodeExampleBlock codeSections={[{ sampleCode: codeExample }]} />
                        </div>
                    </>
                ) : (
                        <>
                            <div className="col-lg-5">
                                <CodeExampleBlock codeSections={[{ sampleCode: codeExample }]} />
                            </div>
                            <div className="col-lg-1"></div>
                            <div className="col-lg-6">
                                <div className="main-content">
                                    <HeadlineAndBodyTextBlock
                                        headlines={[{ headlineValue: h4, headlineType: 'H4' }]}
                                        body={[{ bodyCopy: description }]}
                                    />
                                    {displayImportantNotice && (
                                        <ImportantNoticeBlock notice={importantNotice} />
                                    )}
                                </div>
                            </div>
                        </>
                    )
            }
        </div>
    )
}

const ContentVideo = (values, position) => {
    const [hideMess, setHideMess] = useState(true)
    const {
        h4,
        description,
        displayImportantNotice,
        importantNotice,
        lengthOfVideoMessage,
        videoEmbedCode,
        title,
        url
    } = values

    const handleMess = () => {
        setHideMess(false)
    }

    return (
        <div className="content-row-item">
            {
                position === 'left' ? (
                    <>
                        <div className="col-lg-5">
                            <div className="video-wrapper">
                                <div className="embed-video" dangerouslySetInnerHTML={{ __html: videoEmbedCode }}></div>
                                {hideMess && (
                                    <button onClick={handleMess} className="length-mess">{lengthOfVideoMessage}</button>
                                )}
                            </div>
                        </div>
                        <div className="col-lg-1"></div>
                        <div className="col-lg-6">
                            <div className="main-content">
                                <HeadlineAndBodyTextBlock
                                    headlines={[{ headlineValue: h4, headlineType: 'H4' }]}
                                    body={[{ bodyCopy: description }]}
                                />
                                {displayImportantNotice && (
                                    <ImportantNoticeBlock notice={importantNotice} />
                                )}
                            </div>
                        </div>
                    </>
                ) : (
                        position === 'center' ? (
                            <div className="col-lg-12">
                                <div className="video-wrapper">
                                    <div dangerouslySetInnerHTML={{ __html: videoEmbedCode }}></div>
                                    {hideMess && (
                                        <button onClick={handleMess} className="length-mess">{lengthOfVideoMessage}</button>
                                    )}
                                </div>
                            </div>
                        ) : (
                                <>
                                    <div className="col-lg-6">
                                        <div className="main-content">
                                            <HeadlineAndBodyTextBlock
                                                headlines={[{ headlineValue: h4, headlineType: 'H4' }]}
                                                body={[{ bodyCopy: description }]}
                                                show={true}
                                                button={{
                                                    title: title,
                                                    url: url
                                                }}
                                                showButton={true}
                                            />
                                            {displayImportantNotice && (
                                                <ImportantNoticeBlock notice={importantNotice} />
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-lg-1"></div>
                                    <div className="col-lg-5">
                                        <div className="video-wrapper">
                                            <div className="embed-video" dangerouslySetInnerHTML={{ __html: videoEmbedCode }}></div>
                                            {hideMess && (
                                                <button onClick={handleMess} className="length-mess">{lengthOfVideoMessage}</button>
                                            )}
                                        </div>
                                    </div>
                                </>
                            )
                    )
            }
        </div>
    )
}

const ContentFullWidth = (values) => {
    const { h4, description, displayImportantNotice, importantNotice } = values

    return (
        <div className="col-lg-12">
            <HeadlineAndBodyTextBlock
                headlines={[{ headlineValue: h4, headlineType: 'H4' }]}
                body={[{ bodyCopy: description }]}
            />
            {displayImportantNotice && (
                <ImportantNoticeBlock notice={importantNotice} />
            )}
        </div>
    )
}

const ContentRowBlock = ({ values }) => {
    let content = ''
    switch (values.layout) {
        case 'Image Left':
            content = <ContentImage {...values} />
            break;
        case 'Image Right':
            content = <ContentImage {...values} position={`right`} />
            break;
        case 'SVG Left':
            content = <ContentSvg {...values} />
            break;
        case 'SVG Right':
            content = <ContentSvg {...values} position={`right`} />
            break;
        case 'Code Example Left':
            content = <ContentCodeExample {...values} />
            break;
        case 'Code Example Right':
            content = <ContentCodeExample {...values} position={`right`} />
            break;
        case 'Video Left':
            content = <ContentVideo {...values} position={`left`} />
            break;
        case 'Video Right':
            content = <ContentVideo {...values} />
            break;
        case 'Video Centered':
            content = <ContentVideo {...values} position={`center`} />
            break;
        default:
            content = <ContentFullWidth {...values} />
            break;
    }
    return (
        <>
            {content}
        </>
    )
}

export default ContentRowBlock
